import React, { useState } from 'react';
import { Plus, Trash } from '@phosphor-icons/react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '../ui/dialog';

const ProductsTab = ({ products, onCreateProduct, onDeleteProduct }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [productForm, setProductForm] = useState({ 
    name: '', description: '', price: '', category: '', image_url: '', stock: '' 
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    await onCreateProduct({
      ...productForm,
      price: parseFloat(productForm.price),
      stock: parseInt(productForm.stock) || 0
    });
    setIsDialogOpen(false);
    setProductForm({ name: '', description: '', price: '', category: '', image_url: '', stock: '' });
  };

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl text-white font-outfit">Products</h2>
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
          <DialogTrigger asChild>
            <Button className="bg-[#D4AF37] text-black hover:bg-[#E5C158]">
              <Plus className="w-4 h-4 mr-2" />
              Add Product
            </Button>
          </DialogTrigger>
          <DialogContent className="bg-[#121212] border-white/10">
            <DialogHeader>
              <DialogTitle className="text-white">Add New Product</DialogTitle>
            </DialogHeader>
            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <Label className="text-zinc-400">Name</Label>
                <Input
                  value={productForm.name}
                  onChange={(e) => setProductForm({ ...productForm, name: e.target.value })}
                  className="bg-zinc-900 border-zinc-700 text-white"
                  required
                />
              </div>
              <div>
                <Label className="text-zinc-400">Description</Label>
                <Textarea
                  value={productForm.description}
                  onChange={(e) => setProductForm({ ...productForm, description: e.target.value })}
                  className="bg-zinc-900 border-zinc-700 text-white"
                  required
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <Label className="text-zinc-400">Price ($)</Label>
                  <Input
                    type="number"
                    step="0.01"
                    value={productForm.price}
                    onChange={(e) => setProductForm({ ...productForm, price: e.target.value })}
                    className="bg-zinc-900 border-zinc-700 text-white"
                    required
                  />
                </div>
                <div>
                  <Label className="text-zinc-400">Stock</Label>
                  <Input
                    type="number"
                    value={productForm.stock}
                    onChange={(e) => setProductForm({ ...productForm, stock: e.target.value })}
                    className="bg-zinc-900 border-zinc-700 text-white"
                  />
                </div>
              </div>
              <div>
                <Label className="text-zinc-400">Category</Label>
                <Input
                  value={productForm.category}
                  onChange={(e) => setProductForm({ ...productForm, category: e.target.value })}
                  className="bg-zinc-900 border-zinc-700 text-white"
                  required
                />
              </div>
              <div>
                <Label className="text-zinc-400">Image URL</Label>
                <Input
                  value={productForm.image_url}
                  onChange={(e) => setProductForm({ ...productForm, image_url: e.target.value })}
                  className="bg-zinc-900 border-zinc-700 text-white"
                />
              </div>
              <Button type="submit" className="w-full bg-[#D4AF37] text-black hover:bg-[#E5C158]">
                Create Product
              </Button>
            </form>
          </DialogContent>
        </Dialog>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {products.map((product) => (
          <div key={product.product_id} className="bg-[#121212] border border-white/5 p-4">
            <img 
              src={product.image_url || 'https://via.placeholder.com/100'} 
              alt={product.name} 
              className="w-full h-32 object-cover mb-3" 
            />
            <h3 className="text-white font-medium">{product.name}</h3>
            <p className="text-zinc-400 text-sm mb-2">{product.category}</p>
            <div className="flex justify-between items-center">
              <span className="text-[#D4AF37] font-mono">${product.price}</span>
              <span className="text-zinc-500 text-sm">Stock: {product.stock}</span>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onDeleteProduct(product.product_id)}
              className="mt-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 w-full"
            >
              <Trash className="w-4 h-4 mr-2" />
              Delete
            </Button>
          </div>
        ))}
      </div>
    </>
  );
};

export default ProductsTab;
